(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ImageAPIService', imageAPIService);

    function imageAPIService(HttpService) {
        function getImageUploadS3SignedUrl(type, format) {
            const data = {
                type: type,
                format: format
            };
            return HttpService.get('/Images/ImageUploadSignedUrl?' + $.param(data));
        }

        function getProductThumbnailsS3SignedUrl() {
            return HttpService.get('/Images/ProductThumbnail/SignedUrl');
        }

        function generateImageThumbnail(filename, type = undefined) {
            const data = {
                type: type
            };
            return HttpService.get(`/Images/Thumbnail/${encodeURIComponent(filename)}?${$.param(data)}`);
        }

        function doDynamicImagesNeedResizing(filenames, maxSize) {
            const query = {
                maxSize: maxSize
            };
            const data = {
                filenames: filenames
            };
            return HttpService.post('/Images/DynamicImages/NeedResizing?' + $.param(query), data);
        }

        function doMaskImagesNeedResizing(filenames, maxSize) {
            const query = {
                maxSize: maxSize
            };
            const data = {
                filenames: filenames
            };
            return HttpService.post('/Images/MaskImages/NeedResizing?' + $.param(query), data);
        }

        function resizeDynamicImages(filenames, maxSize) {
            const query = {
                maxSize: maxSize
            };
            const data = {
                filenames: filenames
            };
            return HttpService.post('/Images/DynamicImages/Resize?' + $.param(query), data);
        }

        function resizeMaskImages(filenames, maxSize) {
            const query = {
                maxSize: maxSize
            };
            const data = {
                filenames: filenames
            };
            return HttpService.post('/Images/MaskImages/Resize?' + $.param(query), data);
        }

        return {
            doDynamicImagesNeedResizing: doDynamicImagesNeedResizing,
            doMaskImagesNeedResizing: doMaskImagesNeedResizing,
            resizeDynamicImages: resizeDynamicImages,
            resizeMaskImages: resizeMaskImages,
            getImageUploadS3SignedUrl: getImageUploadS3SignedUrl,
            getProductThumbnailsS3SignedUrl: getProductThumbnailsS3SignedUrl,
            generateImageThumbnail: generateImageThumbnail
        };
    }
})();
